var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "align-center": "",
      "wrap": ""
    }
  }, [_vm.$apollo.queries.userBalance.loading ? _c('v-flex', {
    attrs: {
      "mt-10": "",
      "mb-10": "",
      "text-center": ""
    }
  }, [_c('v-progress-circular', {
    staticClass: "mb-2",
    attrs: {
      "size": 40,
      "color": "primary",
      "indeterminate": ""
    }
  }), _c('br'), _c('b', [_vm._v(_vm._s(_vm.$t('gateway.almostDone')))])], 1) : _vm._e(), !_vm.$apollo.queries.userBalance.loading && _vm.gateway == null && _vm.enoughBalanceFunds && _vm.invoice.tag !== 'deposit_funds' ? _c('v-flex', {
    class: _vm.invoiceId != 0 ? 'xs12' : 'xs5'
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('gateway.orderConfirmation')) + "!!!")]), _vm._v(" " + _vm._s(_vm.$t('gateway.from_balance', {
    amount: _vm.$options.filters.renderSymbol(_vm.balance.currency) + _vm.invoice.total
  })) + " "), _c('center', [_c('v-btn', {
    staticClass: "primary mt-15 mb-5",
    attrs: {
      "block": "",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": function click($event) {
        return _vm.payFromBalance();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('gateway.pay')) + " " + _vm._s(_vm._f("renderSymbol")(_vm.invoice.currency)) + _vm._s(_vm.invoice.total) + " ")])], 1)], 1) : !_vm.$apollo.loading && _vm.gateway == null && (!_vm.enoughBalanceFunds || _vm.invoice.tag === 'deposit_funds') ? _c('v-flex', {
    class: _vm.invoiceId != 0 ? 'xs12' : 'xs5'
  }, [_vm.invoice ? _c('div', {
    staticClass: "gateway-card"
  }, [_vm.invoice.tag !== 'deposit_funds' ? _c('center', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('gateway.insufficientFunds', {
    balance: _vm.$options.filters.renderSymbol(_vm.balance.currency) + _vm.balance.credit,
    total: _vm.$options.filters.renderSymbol(_vm.invoice.currency) + _vm.invoice.total
  })) + " ")]), _c('h4', {
    staticClass: "mt-5 mb-5"
  }, [_vm._v(" " + _vm._s(_vm.$t('gateway.refill')) + " " + _vm._s(_vm._f("renderSymbol")(_vm.invoice.currency)) + _vm._s(_vm.invoiceDiff) + " ")])]) : _c('center', [_c('h4', {
    staticClass: "mt-5 mb-5"
  }, [_vm._v(" " + _vm._s(_vm.$t('gateway.refillDeposit')) + " " + _vm._s(_vm._f("renderSymbol")(_vm.invoice.currency)) + _vm._s(_vm.invoice.total) + " ")])]), _c('v-layout', {
    attrs: {
      "wrap": "",
      "mt-5": "",
      "mb-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "method",
    attrs: {
      "ripple": false
    }
  }, [_c('center', [_c('div', {
    staticClass: "crypto"
  }, [_c('v-img', {
    attrs: {
      "src": require('@/images/crypto/btc.svg'),
      "alt": "cc",
      "max-width": "50",
      "contain": ""
    }
  }), _c('v-img', {
    attrs: {
      "src": require('@/images/crypto/eth.svg'),
      "alt": "cc",
      "max-width": "50",
      "contain": ""
    }
  }), _c('v-img', {
    attrs: {
      "src": require('@/images/crypto/usdt.svg'),
      "alt": "cc",
      "max-width": "50",
      "contain": ""
    }
  })], 1)])], 1)], 1), _c('v-flex', {
    attrs: {
      "ml-5": "",
      "mb-2": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    staticClass: "mt-3",
    attrs: {
      "items": _vm.cpayConfig,
      "item-text": 'name',
      "item-value": 'id',
      "name": "currency"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(data.item.name))]), _c('small', {
          staticClass: "text-neutral"
        }, [_vm._v(_vm._s(data.item.description))])], 1)];
      }
    }, {
      key: "item",
      fn: function fn(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(data.item.name))]), _c('br'), _c('small', {
          staticClass: "text-neutral"
        }, [_vm._v(_vm._s(data.item.description))])], 1)];
      }
    }], null, false, 2251810781),
    model: {
      value: _vm.selectedCurrency,
      callback: function callback($$v) {
        _vm.selectedCurrency = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "selectedCurrency"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('withdrawals.selectCurrency')))])])], 2), _vm.error && !_vm.selectedCurrency ? _c('small', {
    staticClass: "text-danger"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("gateway.choosePaymentCurrency")))])]) : _vm._e()], 1), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": "",
      "ml-5": "",
      "mb-2": ""
    }
  }, [_c('center', [_c('v-btn', {
    staticClass: "primary mt-5 mb-8",
    attrs: {
      "block": "",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": function click($event) {
        return _vm.pay();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('gateway.pay')) + " " + _vm._s(_vm._f("renderSymbol")(_vm.invoice.currency)) + _vm._s(_vm.invoice.tag === 'deposit_funds' ? _vm.invoice.total : _vm.invoiceDiff) + " ")])], 1)], 1)], 1)], 1) : _c('div', {
    staticClass: "mt-5 mb-5"
  }, [_c('center', [_vm._v(" " + _vm._s(_vm.$t('gateway.notAvaliable')) + " ")])], 1)]) : _vm._e(), _vm.gateway === 'cpay' ? _c('coinpayments', {
    attrs: {
      "invoice": _vm.invoiceCopy,
      "currency": _vm.selectedCurrencyObj.name,
      "protocol": _vm.selectedCurrencyObj.description,
      "currency-id": _vm.selectedCurrency
    },
    on: {
      "backToStep2": _vm.removeTransactionHandler
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }